<template>
  <v-app>

    <VibrateComponent></VibrateComponent>

<!--    <v-card class="container" style="margin-top: 3%" tile>-->
<!--      <v-spacer></v-spacer>-->
<!--      <p style="margin: 10px;">&copy; {{ new Date().getFullYear() }} | <span style="background-color: white; padding-left: 5px; padding-right: 5px" class="indigo&#45;&#45;text"> vibratez </span></p>-->
<!--    </v-card>-->

  </v-app>
</template>

<script>
  const VibrateComponent = () => import('./components/VibrateComponent');

  export default {
    components : {
      VibrateComponent
    },
    data () {
      return {
        tab: null,
      }
    },
  }
</script>
